// extracted by mini-css-extract-plugin
export default {"link":"link--FWu_7","icon":"icon--oqS7B","iconWithCaption":"iconWithCaption--yKkc5","caption":"caption--rIXSr"};